import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const Academics = () => {  
  useEffect(() => {
    document.title = 'Academics - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Academics</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                      <p>St. Francis Xavier follows the Curriculum of the Central Board of Secondary Education (CBSE), Delhi and prepares the students for All India Secondary School Examination(AISSE) and the All India Senior School Certificate Examination(AISSCE) at class X and XII levels respectively. Medium of instruction is English. Hindi or Sanskrit is offered as a second language upto class X. Sanskrit is being studied as a third language for class VI to VIII.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default Academics;
